import { apiPaths } from '@core/http/apiPaths';
import httpClient from '@core/http/httpClient';
import { EntityReducers } from '@core/store/EntityReducers';
import { PreferencesAPIModel, PreferencesModel } from '@models/Preferences';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { mapPreferencesFromApi, mapPreferencesToApi } from '@shared/components/Preferences/Preferences.utils';
import { AxiosResponse } from 'axios';

const getUserPreferences = createAsyncThunk<PreferencesModel>(
  `${EntityReducers.preferences}/getUserPreferences`,
  async () => {
    const response: AxiosResponse<PreferencesAPIModel> = await httpClient.get(apiPaths.preferences.preferences);

    return mapPreferencesFromApi(response.data);
  }
);

interface UserPreferencesThunkModel {
  data: PreferencesModel;
}

const saveUserPreferences = createAsyncThunk<UserPreferencesThunkModel, UserPreferencesThunkModel>(
  `${EntityReducers.preferences}/saveUserPreferences`,
  async ({ data }) => {
    const response: AxiosResponse = await httpClient.put(apiPaths.preferences.preferences, mapPreferencesToApi(data));

    return { ...response.data, data };
  }
);

interface GetAccountPreferencesThunk {
  accountId: number;
}

const getAccountPreferences = createAsyncThunk<
  PreferencesModel & GetAccountPreferencesThunk,
  GetAccountPreferencesThunk
>(`${EntityReducers.preferences}/getAccountPreferences`, async ({ accountId }) => {
  const response: AxiosResponse<PreferencesAPIModel> = await httpClient.get(
    apiPaths.accounts.preferences({ accountId: accountId.toString() })
  );

  return { ...mapPreferencesFromApi(response.data), accountId };
});

interface SaveAccountPreferencesThunk extends GetAccountPreferencesThunk {
  data: PreferencesModel;
}

const saveAccountPreferences = createAsyncThunk<SaveAccountPreferencesThunk, SaveAccountPreferencesThunk>(
  `${EntityReducers.preferences}/saveAccountPreferences`,
  async ({ accountId, data }) => {
    const response: AxiosResponse = await httpClient.put(
      apiPaths.accounts.preferences({ accountId: accountId.toString() }),
      mapPreferencesToApi(data)
    );

    return { ...response.data, accountId, data };
  }
);

export const thunks = {
  getUserPreferences,
  saveUserPreferences,
  getAccountPreferences,
  saveAccountPreferences,
};
